var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"@/assets/projects/projects.css","type":"text/css"}}),_c('Header'),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }